import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "BaseAvailability__body q-pb-40" }
const _hoisted_2 = { class: "flex column gap-lg" }
const _hoisted_3 = { class: "flex justify-between items-center q-px-sm" }

import { ICalloutProps } from 'src/common/interfaces'
import useBaseAvailabilityHook from './BaseAvailabilityHook'
import AvailabilityTable from 'components/AvailabilityTable/AvailabilityTable.vue'
import { IBaseAvailabilityEmits, IBaseAvailabilityProps } from './interfaces/baseAvailability.interface'
import AvailabilityDialog from '../AvailabilityDialog/AvailabilityDialog.vue'


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'BaseAvailability' },
  __name: 'BaseAvailability',
  props: /*@__PURE__*/_mergeModels({
    title: { default: 'Availability' },
    availabilities: { default: () => [] },
    salesTypes: { default: () => [] },
    callout: { default: () => ({}) as ICalloutProps }
  }, {
    "modelValue": { type: Object, default: () => ({}) },
    "modelModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["manage"], ["update:modelValue"]),
  setup(__props: any) {


const model = _useModel(__props, "modelValue")
const props = __props

const { state, ...hook } = useBaseAvailabilityHook({ props, model })

return (_ctx: any,_cache: any) => {
  const _component_k_toggle = _resolveComponent("k-toggle")!
  const _component_k_divider = _resolveComponent("k-divider")!
  const _component_k_accordion = _resolveComponent("k-accordion")!

  return (_openBlock(), _createBlock(_component_k_accordion, {
    title: __props.title,
    callout: {
      ...__props.callout,
      position: 'side-left-up',
    },
    class: "BaseAvailability"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "default", {}, () => [
            _createCommentVNode(" <div class=\"flex justify-end q-px-sm\">\n            <k-btn\n              model=\"secondary\"\n              size=\"md\"\n              icon=\"calendar\"\n              class=\"q-px-lg\"\n              :label=\"hook.t('button')\"\n              :is-right-icon=\"true\"\n              @click=\"$emit('manage')\"\n            />\n          </div> ")
          ]),
          _createCommentVNode(" <k-divider /> "),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", {
              class: _normalizeClass(["block fs-15px fw-500", _unref(state).salesTypeToggle ? 'text-cool-gray-100' : 'text-cool-gray-70'])
            }, _toDisplayString(hook.t('toggle')), 3 /* TEXT, CLASS */),
            _createVNode(_component_k_toggle, {
              modelValue: _unref(state).salesTypeToggle,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).salesTypeToggle) = $event))
            }, null, 8 /* PROPS */, ["modelValue"])
          ]),
          (_unref(state).salesTypeToggle)
            ? (_openBlock(), _createBlock(_component_k_divider, { key: 0 }))
            : _createCommentVNode("v-if", true),
          _createVNode(AvailabilityTable, {
            columns: _unref(state).tableCols,
            rows: _unref(state).tableRows,
            "sales-type-toggle": _unref(state).salesTypeToggle,
            availabilities: _unref(state).availabilities,
            onView: hook.showAvailabilityDetails
          }, null, 8 /* PROPS */, ["columns", "rows", "sales-type-toggle", "availabilities", "onView"])
        ]),
        _createVNode(AvailabilityDialog, {
          modelValue: _unref(state).availabilityDialog,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(state).availabilityDialog) = $event)),
          data: _unref(state).availabilityDetails
        }, null, 8 /* PROPS */, ["modelValue", "data"])
      ])
    ]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["title", "callout"]))
}
}

})